import checkIcon from '@src/main/assets/icons/check-red.svg';
import crossIcon from '@src/main/assets/icons/cross-red.svg';
import editIcon from '@src/main/assets/icons/edit-red.svg';
import refreshIcon from '@src/main/assets/icons/refresh-red.svg';
import { Parameter } from '@src/main/modules/parameters/domain/parameters-management/parameter.interface';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { FC } from 'react';
import styles from './ParametersSection.module.scss';

interface ParameterSectionProps {
  title: string;
  parameters: Parameter[];
  editMode: boolean;
  type?: 'text' | 'textarea' | 'switch';
  onEdit: () => void;
  onRefresh: () => void;
  onAccept: () => void;
  onRefuse: () => void;
  onChange: (p: Parameter, value: string | boolean) => void;
  hasEditPermission: boolean;
}

const ParameterSection: FC<ParameterSectionProps> = ({
  title,
  parameters,
  editMode,
  type = 'text',
  onEdit,
  onRefresh,
  onAccept,
  onRefuse,
  onChange,
  hasEditPermission,
}) => (
  <Accordion multiple activeIndex={[0]} className={styles.accordion}>
    <AccordionTab
      header={
        <div className={styles.header}>
          <span>{title}</span>
        </div>
      }
    >
      <div className={styles.content}>
        <div className={styles.actions}>
          {!editMode ? (
            <>
              {hasEditPermission && (
                <Button
                  icon={<img src={editIcon} alt="Editar" width="15" />}
                  onClick={onEdit}
                  tooltip="Editar"
                />
              )}
              <Button
                icon={<img src={refreshIcon} alt="Refrescar" width="15" />}
                onClick={onRefresh}
                tooltip="Refrescar"
              />
            </>
          ) : (
            <>
              <Button
                icon={<img src={checkIcon} alt="Aceptar" width="15" />}
                onClick={onAccept}
                tooltip="Aceptar"
                className="p-button-success"
              />
              <Button
                icon={<img src={crossIcon} alt="Cancelar" width="15" />}
                onClick={onRefuse}
                tooltip="Cancelar"
                className="p-button-danger"
              />
            </>
          )}
        </div>

        {parameters.map((param) => (
          <div className={styles.field} key={param.parameter}>
            <div className={styles.inputContainer}>
              <label htmlFor={param.parameter}>{param.description}</label>

              {type === 'text' && (
                <InputText
                  id={param.parameter}
                  value={String(param.value)}
                  onChange={(e) => onChange(param, e.target.value)}
                  disabled={!editMode}
                  className={styles.fullWidth}
                />
              )}

              {type === 'textarea' && (
                <InputTextarea
                  id={param.parameter}
                  value={String(param.value)}
                  onChange={(e) => onChange(param, e.target.value)}
                  disabled={!editMode}
                  rows={5}
                  autoResize
                  className={styles.fullWidth}
                />
              )}

              {type === 'switch' && (
                <div className={styles.switchContainer}>
                  <InputSwitch
                    checked={Boolean(param.value)}
                    onChange={(e) => onChange(param, e.value)}
                    disabled={!editMode}
                    className={styles.customSwitch}
                    pt={{
                      slider: {
                        style: {
                          backgroundColor: param.value ? 'var(--primary-color)' : '#ccc',
                        },
                      },
                    }}
                  />
                  <span className={styles.switchLabel}>Estado de funcionalidad</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </AccordionTab>
  </Accordion>
);

export default ParameterSection;
